import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { hash: String, url: String }

  async copy(event) {
    event.preventDefault()
    const url = new URL(window.location.href)
    url.hash = this.hashValue
    try {
      await navigator.clipboard.writeText(url.toString())
      window.toast("Link copied", { kind: "success" })
    } catch (_) {
      window.toast("Couldn't copy link", { kind: "alert" })
    }
  }

  async copyUrl(event) {
    event.preventDefault()
    try {
      await navigator.clipboard.writeText(this.urlValue)
      window.toast("URL copied", { kind: "success" })
    } catch (_) {
      window.toast("Couldn't copy URL", { kind: "alert" })
    }
  }
}
